import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import { getMenuItems } from '@/exceed';

import getVideoMenuItems from '../helpers/getVideoMenuItems';

import styles from '../styles/videosAdminListDragAndDropKebabMenu.module.scss';

const VideosAdminListDragAndDropKebabMenu = ({ item, onKebabMenuItemClick, onIsOpenChange }) => (
  <Menu
    className={styles.element}
    shouldAnimate={false}
    onIsOpenChange={onIsOpenChange}
    component={(
      <Button
        size="xsmall"
        variant="ghost"
        icon={<MoreHoriz />}
      />
    )}
  >
    <ul>
      {getMenuItems(getVideoMenuItems({ item, onKebabMenuItemClick, params: useParams() }))}
    </ul>
  </Menu>
);

VideosAdminListDragAndDropKebabMenu.defaultProps = {
  onIsOpenChange: () => {},
};

VideosAdminListDragAndDropKebabMenu.propTypes = {
  item: PropTypes.shape({}).isRequired,
  onKebabMenuItemClick: PropTypes.func.isRequired,
  onIsOpenChange: PropTypes.func,
};

export default React.memo(VideosAdminListDragAndDropKebabMenu);
